
import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
import { Utilizador } from '@app/model/utilizador';
import { map } from 'rxjs/operators';
import { Filtro, Ordem, Paginacao, Pesquisa } from '@app/model/util';


@Injectable({
  providedIn: 'root'
})
export class UtilizadoresService {

  options: {
    headers?: HttpHeaders | { [header: string]: string | string[] },
    observe?: 'body' | 'events' | 'response',
    params?: HttpParams | { [param: string]: string | string[] },
    reportProgress?: boolean,
    responseType?: 'arraybuffer' | 'blob' | 'json' | 'text',
    withCredentials?: boolean,
  }

  // Apontamos ao 4200(front) porque temos a proxy aplicada
  url = '/apiat';

  urlLista = "/utilizador/lista";
  urlSearch = "/utilizador/search";
  urlCount = "/utilizador/count";
  urlObter = "/utilizador/";
  urlInserirAlterar = "/utilizador";
  urlRemover = "/utilizador/";


  // injetando o HttpClient
  constructor(
    private http: HttpClient
  ) {
  }

  // Headers
  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  }

  //  /** GET utilizadores from the server */

  list(): Observable<Utilizador[]> {
    return this.http.get<Utilizador[]>(this.url + this.urlLista)
      .pipe(
        retry(2), // numero de x que executa chamada se obtiver erro
        catchError(this.handleError)
      )
  }

  search(pesquisa: Pesquisa): Observable<Utilizador[]> {
    return this.http.post<Utilizador[]>(this.url + this.urlSearch, JSON.stringify(pesquisa), this.httpOptions)
      .pipe(
        retry(2), // numero de x que executa chamada se obtiver erro
        catchError(this.handleError)
      )
  }

  count(filtro: Filtro): Observable<Number> {
    return this.http.post<Number>(this.url + this.urlCount, JSON.stringify(filtro), this.httpOptions)
      .pipe(
        retry(2), // numero de x que executa chamada se obtiver erro
        catchError(this.handleError)
      )
  }
  // Obter utilizador pelo id
  get(id: string): Observable<Utilizador> {
    return this.http.get<Utilizador>(this.url + this.urlObter + id)
      .pipe(
        retry(2),
        catchError(this.handleError)
      )
  }

  //////// Save methods //////////

  /** POST: add/edit a client to the database */
  save(utilizador: Utilizador): Observable<void> {
    console.log('save POST ' + this.url + this.urlInserirAlterar);
    console.log(utilizador);
    return this.http.post<void>(this.url + this.urlInserirAlterar, JSON.stringify(utilizador), this.httpOptions)
      .pipe(
        retry(2),
        catchError(this.handleError)
      )
  }

  /** DELETE: delete the client from the server */
  delete(utilizador: Utilizador) {
    return this.http.delete<Utilizador>(this.url + this.urlRemover + utilizador.username, this.httpOptions)
      .pipe(
        retry(1),
        catchError(this.handleError)
      )
  }



  // Manipulação de erros
  //O angular recomenda que métodos de manipulação de erros devem ser nos serviços e não nos componentes.
  handleError(error: HttpErrorResponse) {
    let errorMessage = '';
    //console.log(error);
    //console.log(error.error);
    //console.log(error.error.typeof());
    if (typeof(error.error) == "string") {
      errorMessage = error.error;
    } else if (error.error instanceof ErrorEvent) {
      // Erro ocorreu no lado do client
      errorMessage = error.error.message;
    } else {
      // Erro ocorreu no lado do servidor
      errorMessage = `Código do erro: ${error.status}, ` + `mensagem: ${error.message}`;
    }
    console.log(errorMessage);
    return throwError(errorMessage);
  };

}
